import React, { useState } from 'react'
import * as Styles from './styles'

type Props = {
  children: JSX.Element
  content?: JSX.Element
  direction?: 'top' | 'right' | 'bottom' | 'left'
  style?: object
  title?: string | string[]
}

const Tooltip: React.FC<any> = (props: Props) => {
  const [showTooltip, setShowTooltip] = useState<boolean>(false)
  const renderTitle = () => {
    if (Array.isArray(props.title)) {
      return (
        <Styles.TooltipText className={props.direction}>
          {props.title.map((element, index) => (
            <div key={index} className={'arrayItem'}>
              {element}
            </div>
          ))}
        </Styles.TooltipText>
      )
    }

    if (props.content) {
      return (
        <Styles.TooltipText className={props.direction}>
          {props.content}
        </Styles.TooltipText>
      )
    }

    return (
      <Styles.TooltipText className={props.direction}>
        {props.title}
      </Styles.TooltipText>
    )
  }

  return (
    <Styles.Tooltip
      onMouseEnter={() => setShowTooltip(true)}
      onMouseLeave={() => setShowTooltip(false)}
    >
      {props.children}
      {showTooltip && renderTitle()}
    </Styles.Tooltip>
  )
}

Tooltip.defaultProps = {
  direction: 'top',
}

export default Tooltip
